import { api, tokens, userCache, apiEnabled } from './api.js';

export async function login(email, password) {
  const data = await api('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
    skipAuth: true,
  });
  tokens.set(data.accessToken, data.refreshToken);
  userCache.set(data.user);
  return data.user;
}

export async function register(email, password, name) {
  const data = await api('/api/auth/register', {
    method: 'POST',
    body: JSON.stringify({ email, password, name }),
    skipAuth: true,
  });
  tokens.set(data.accessToken, data.refreshToken);
  userCache.set(data.user);
  return data.user;
}

export async function logout() {
  if (apiEnabled && tokens.refresh) {
    try {
      await api('/api/auth/logout', {
        method: 'POST',
        body: JSON.stringify({ refreshToken: tokens.refresh }),
      });
    } catch {}
  }
  tokens.clear();
}

export async function fetchMe() {
  if (!apiEnabled || !tokens.access) return null;
  try {
    const data = await api('/api/auth/me');
    if (data?.user) userCache.set(data.user);
    return data?.user ?? null;
  } catch {
    return null;
  }
}

export const getCurrentUser = () => userCache.get();

// Always resolves with the same shape — the backend never reveals whether
// the email exists. Caller should display a generic "if registered, you'll
// receive an email" message no matter what.
export async function forgotPassword(email) {
  await api('/api/auth/forgot-password', {
    method: 'POST',
    body: JSON.stringify({ email }),
    skipAuth: true,
  });
}

export async function resetPassword(token, password) {
  await api('/api/auth/reset-password', {
    method: 'POST',
    body: JSON.stringify({ token, password }),
    skipAuth: true,
  });
}
